import { useState } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { callApi } from '../utils/apiClient';


const useAddShift = ({ shiftCodeStatus, setShiftID,CallMessage,loading,setLoading }) => {
//   const [loading, setLoading] = useState(false);

  const formatTime = (time) => time ? new Date(time).toLocaleTimeString('en-US', { hour12: false }) : '00:00:00';

  const addShift = async ({
    shiftCode,
    checkInTime,
    checkOutTime,
    breakDurationMins,
    description,
    breaks,
    editShiftID,
  }) => {
    try {
      // 🔒 Validation
      if (shiftCodeStatus === true) {
        CallMessage('warning', 'Shift code already exists. Please use a unique code.', 'Validation');
        return false;
      }

      if (!shiftCode?.trim()) {
        CallMessage('warning', 'Shift code is required.', 'Validation');
        return false;
      }

      if (!checkInTime || !checkOutTime) {
        CallMessage('warning', 'Start and End times are required.', 'Validation');
        return false;
      }

      let shiftvalue = editShiftID || 0;

      const para = {
        p_id_shift: shiftvalue,
        p_shift_name: shiftCode.trim(),
        p_start_time: formatTime(checkInTime),
        p_end_time: formatTime(checkOutTime),
        p_break_duration_mins: breakDurationMins || 0,
        p_description: description?.trim() || '',
        p_created_by: localStorage.getItem('userID') || 'Unknown',
        p_companyid: localStorage.getItem('companyid') || 0,
        p_plantid: 1,
        p_break_detail: breaks || [],
      };

      const CallQuery = editShiftID === 0
        ? API_ENDPOINTS.HR_SHIFT_MASTER_ADD
        : API_ENDPOINTS.HR_SHIFT_MASTER_UPDATE;

      setLoading(true);

      const data = await callApi(CallQuery, 'POST', { 'Content-Type': 'application/json' }, para);

      if (data?.length > 0) {
        if (shiftvalue === 0) {
          CallMessage('success', 'Shift saved successfully', 'Info');
          setShiftID(data[0].id);
        } else {
          CallMessage('success', 'Shift updated successfully', 'Info');
        }
        return true;
      }

      return false;
    } catch (error) {
      CallMessage('error', error.message || 'An error occurred', 'Error');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { addShift, loading };
};

export default useAddShift;
